var userStoreMutations;
(function (userStoreMutations) {
    userStoreMutations["SET_USER"] = "SET_USER";
    userStoreMutations["CLEAR_USER"] = "CLEAR_USER";
    userStoreMutations["CHANGE_STATE"] = "CHANGE_STATE";
    userStoreMutations["CHANGE_CONTACT_PERSON_STATE"] = "CHANGE_CONTACT_PERSON_STATE";
})(userStoreMutations || (userStoreMutations = {}));
export default userStoreMutations;
